import React, { useState } from 'react';
import { Monitor, X } from 'lucide-react';

// One-time, dismissible, MOBILE-ONLY heads-up that a few power tools + the
// full-width dashboard are best on desktop. Mobile hides some Inventory-header
// tools (CSV import/export, cert import, bulk cost) with no other signal, so
// without this a mobile dealer never knows they exist.
const KEY = 'scn-desktop-hint';

export default function DesktopHint() {
  const [hidden, setHidden] = useState(() => {
    try {
      if (localStorage.getItem(KEY) === '1') return true;
      // Only relevant on small screens.
      return !window.matchMedia?.('(max-width: 768px)')?.matches;
    } catch { return true; }
  });
  if (hidden) return null;

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 10, padding: '9px 14px',
      background: 'var(--bg-muted, #f1f5f9)', border: '1px solid var(--border, #e5e7eb)',
      borderRadius: 10, margin: '0 0 12px', fontSize: 12.5, color: 'var(--text-secondary, #475569)',
    }}>
      <Monitor size={15} style={{ flexShrink: 0, color: 'var(--text-tertiary, #94a3b8)' }} />
      <span style={{ flex: 1, lineHeight: 1.4 }}>
        SCN works great on your phone, but bulk tools (CSV import, cost entry) and the full-width dashboard are even better on a computer at <strong>sportscardnetwork.ai</strong>.
      </span>
      <button onClick={() => { try { localStorage.setItem(KEY, '1'); } catch {} setHidden(true); }}
        aria-label="Dismiss" style={{ background: 'none', border: 'none', color: 'var(--text-tertiary, #94a3b8)', cursor: 'pointer', padding: 4, lineHeight: 1, display: 'flex', flexShrink: 0 }}>
        <X size={14} />
      </button>
    </div>
  );
}
